<template>
    <div class="search-input-box" :class="containerClass">
        <div class="title_container" v-if="inMore">
            <div class="title_mid">{{ label }}</div>
            <div
                class="advance"
                v-if="needSqftSwitch"
                @click="switchAcre(isSqft)"
            >
                {{
                    isSqft
                        ? $t('md-search-bar.switchToAcre')
                        : $t('md-search-bar.switchToSqft')
                }}
            </div>
            <div
                class="advance"
                v-if="needAdvanced"
                @click="switchAdvanced(isAdvanced)"
            >
                {{
                    isAdvanced
                        ? $t('md-search-bar.simple0')
                        : $t('md-search-bar.advanced')
                }}
            </div>
        </div>
        <div class="content" :class="contentClass">
            <div
                class="advance_wrap"
                :class="advanceWrapClass"
                v-if="needAdvanced && inMore"
            >
                <div class="single" :class="singleClass" v-if="!isAdvanced">
                    <div class="label no_wrap">
                        {{ $t('md-search-bar.lessThan') }}
                    </div>
                    <input-dropdown
                        v-bind="$attrs"
                        key="max"
                        :theme="theme"
                        :placeholder="maxTitle"
                        v-model:value="maxVal"
                        :options="maxOpts"
                        :inMore="inMore"
                        :dataType="dataType"
                        @blur="valueChange"
                    >
                        <template #prependAny>
                            <span>{{ $t('md-search-bar.any') }}</span>
                        </template>
                    </input-dropdown>
                </div>
                <div class="multiple" :class="mutipleClass" v-else>
                    <div class="item">
                        <div class="label no_wrap">
                            {{ $t('md-search-bar.moreThan') }}
                        </div>
                        <input-dropdown
                            v-bind="$attrs"
                            :theme="theme"
                            key="min"
                            :placeholder="minTitle"
                            v-model:value="minVal"
                            :options="minOpts"
                            :inMore="inMore"
                            :dataType="dataType"
                            @blur="valueChange"
                        >
                            <template #prependAny>
                                <span>{{ $t('md-search-bar.any') }}</span>
                            </template>
                        </input-dropdown>
                    </div>
                    <div class="split"></div>
                    <div class="item">
                        <div class="label no_wrap">
                            {{ $t('md-search-bar.lessThan') }}
                        </div>
                        <input-dropdown
                            v-bind="$attrs"
                            :theme="theme"
                            :placeholder="maxTitle"
                            v-model:value="maxVal"
                            :options="maxOpts"
                            :inMore="inMore"
                            :dataType="dataType"
                            @blur="valueChange"
                        >
                            <template #prepend>
                                <slot name="prepend"></slot>
                            </template>
                            <template #append>
                                <slot name="append"></slot>
                            </template>
                            <template #prependAny>
                                <span>{{ $t('md-search-bar.any') }}</span>
                            </template>
                        </input-dropdown>
                    </div>
                </div>
            </div>
            <div class="outside-advance_wrap" v-if="needAdvanced && !inMore">
                <div class="outside_dropdown">
                    <div class="single" :class="singleClass" v-if="!isAdvanced">
                        <div class="label no_wrap">
                            {{ $t('md-search-bar.lessThan') }}
                        </div>
                        <input-dropdown
                            v-bind="$attrs"
                            key="max"
                            :theme="theme"
                            :placeholder="maxTitle"
                            v-model:value="maxVal"
                            :options="maxOpts"
                            :inMore="inMore"
                            :dataType="dataType"
                            @blur="valueChange"
                        >
                            <template #prependAny>
                                <span>{{ $t('md-search-bar.any') }}</span>
                            </template>
                        </input-dropdown>
                    </div>
                    <div class="multiple" :class="mutipleClass" v-else>
                        <div class="item">
                            <div class="label no_wrap">
                                {{ $t('md-search-bar.moreThan') }}
                            </div>
                            <input-dropdown
                                v-bind="$attrs"
                                :theme="theme"
                                key="min"
                                :placeholder="minTitle"
                                v-model:value="minVal"
                                :options="minOpts"
                                :inMore="inMore"
                                :dataType="dataType"
                                @blur="valueChange"
                            >
                                <template #prependAny>
                                    <span>{{ $t('md-search-bar.any') }}</span>
                                </template>
                            </input-dropdown>
                        </div>
                        <div class="split"></div>
                        <div class="item">
                            <div class="label no_wrap">
                                {{ $t('md-search-bar.lessThan') }}
                            </div>
                            <input-dropdown
                                key="max"
                                :theme="theme"
                                :placeholder="maxTitle"
                                v-model:value="maxVal"
                                :options="maxOpts"
                                :inMore="inMore"
                                :dataType="dataType"
                                v-bind="$attrs"
                                @blur="valueChange"
                            >
                                <template #prepend>
                                    <slot name="prepend"></slot>
                                </template>
                                <template #append>
                                    <slot name="append"></slot>
                                </template>
                                <template #prependAny>
                                    <span>{{ $t('md-search-bar.any') }}</span>
                                </template>
                            </input-dropdown>
                        </div>
                    </div>
                </div>
                <div
                    class="advanceBtn"
                    :class="advancedClass"
                    @click="switchAdvanced(isAdvanced)"
                >
                    {{
                        isAdvanced
                            ? $t('md-search-bar.simple0')
                            : $t('md-search-bar.advanced')
                    }}
                </div>
            </div>
            <div class="outside-advance_wrap" v-if="needSqftSwitch && !inMore">
                <div class="outside_dropdown">
                    <div class="multiple" :class="mutipleClass">
                        <!-- left -->
                        <div class="item">
                            <input-dropdown
                                v-bind="$attrs"
                                :theme="theme"
                                key="min"
                                :placeholder="minTitle"
                                v-model:value="minVal"
                                :options="minOpts"
                                :dataType="dataType"
                                :inMore="inMore"
                                :isSqft="isSqft"
                                :kee="kee"
                                @blur="valueChange"
                            >
                                <template #prependAny>
                                    <span>{{ $t('md-search-bar.any') }}</span>
                                </template>
                            </input-dropdown>
                        </div>
                        <div class="split"></div>
                        <!-- right -->
                        <div class="item">
                            <input-dropdown
                                v-bind="$attrs"
                                key="max"
                                :theme="theme"
                                :placeholder="maxTitle"
                                v-model:value="maxVal"
                                :options="maxOpts"
                                :dataType="dataType"
                                :inMore="inMore"
                                :isSqft="isSqft"
                                @blur="valueChange"
                            >
                                <template #prependAny>
                                    <span>{{ $t('md-search-bar.any') }}</span>
                                </template>
                            </input-dropdown>
                        </div>
                    </div>
                </div>
                <div
                    class="advanceBtn"
                    :class="advancedClass"
                    @click="switchAcre(isSqft)"
                >
                    {{
                        isSqft
                            ? $t('md-search-bar.switchToAcre')
                            : $t('md-search-bar.switchToSqft')
                    }}
                </div>
            </div>
            <div
                class="normal"
                :class="normalClass"
                v-if="!needAdvanced && (!needSqftSwitch || inMore)"
            >
                <!-- left -->
                <div class="item">
                    <input-dropdown
                        v-bind="$attrs"
                        :theme="theme"
                        key="min"
                        :placeholder="minTitle"
                        v-model:value="minVal"
                        :options="minOpts"
                        :dataType="dataType"
                        :inMore="inMore"
                        :isSqft="isSqft"
                        :kee="kee"
                        @blur="valueChange"
                    >
                        <template #prependAny>
                            <span>{{ $t('md-search-bar.any') }}</span>
                        </template>
                    </input-dropdown>
                </div>
                <div class="split"></div>
                <!-- right -->
                <div class="item">
                    <input-dropdown
                        v-bind="$attrs"
                        key="max"
                        :theme="theme"
                        :placeholder="maxTitle"
                        v-model:value="maxVal"
                        :options="maxOpts"
                        :dataType="dataType"
                        :inMore="inMore"
                        :isSqft="isSqft"
                        @blur="valueChange"
                    >
                        <template #prependAny>
                            <span>{{ $t('md-search-bar.any') }}</span>
                        </template>
                    </input-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import classNames from 'classnames';
import InputDropdown from '../input-dropdown/index.vue';
import common from '../../_mixins/input-box-center';
export default {
    name: 'InputBox',
    mixins: [common],
    components: {
        'input-dropdown': InputDropdown
    },
    emits: ['update:value'],
    props: {
        theme: {
            validator: val =>
                ['standard', 'template1', 'template4', 'broker'].includes(val),
            default: 'standard'
        },
        label: {
            // title
            type: String,
            default: ''
        },
        value: {
            // v-model
            type: String,
            default: ''
        },
        minTitle: {
            // left placeholder
            type: String,
            default: ''
        },
        maxTitle: {
            // right placeholder
            type: String,
            default: ''
        },
        split: {
            type: String,
            default: ','
        },
        inMore: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value() {
            const [v1, v2] = this.getValue();
            if (v1 && v2) {
                this.minVal = Math.min(Number(v1), Number(v2)) + ''; // toString
                this.maxVal = Math.max(Number(v1), Number(v2)) + '';
            } else {
                this.minVal = v1 || '';
                this.maxVal = v2 || '';
            }
        }
    },
    data: function() {
        return {
            minVal: this.value.split(this.split)[0] || '',
            maxVal: this.value.split(this.split)[1] || ''
        };
    },
    computed: {
        containerClass() {
            return classNames(this.theme);
        },
        contentClass() {
            return classNames(this.theme);
        },
        singleClass() {
            return classNames(this.theme);
        },
        mutipleClass() {
            return classNames(this.theme);
        },
        normalClass() {
            return classNames(this.theme, { outside: !this.inMore });
        },
        advanceWrapClass() {
            return classNames({ outside: !this.inMore });
        },
        advancedClass() {
            return classNames(this.theme);
        }
    },
    methods: {
        // Lost focus callbackocus callbackocus callback
        valueChange() {
            let minVal = this.minVal,
                maxVal = this.maxVal;
            if (this.maxVal && Number(this.minVal) > Number(this.maxVal)) {
                minVal = this.maxVal;
                maxVal = this.minVal;
                this.minVal = minVal;
                this.maxVal = maxVal;
            }
            const val = `${minVal}${this.split}${maxVal}`;
            //  only when the value changes emit
            this.value !== val && this.$emit('update:value', val);
        },
        getValue() {
            const [v1, v2] = this.value.split(this.split);
            return [v1, v2];
        },
        switchAcre(isSqft) {
            const unit = isSqft ? 'acre' : 'sqft';
            //  becomes acre
            if (isSqft) {
                this.$emit(
                    'update:value',
                    `${this.sqftToAcre(this.minVal)}${
                        this.split
                    }${this.sqftToAcre(this.maxVal)}`
                );
            } else {
                this.$emit(
                    'update:value',
                    `${this.acreToSqft(this.minVal)}${
                        this.split
                    }${this.acreToSqft(this.maxVal)}`
                );
            }
            this.updateUiConfig({
                sqft: unit
            });
        },
        switchAdvanced(isAdvanced) {
            const type = isAdvanced ? 'simple' : 'advanced';
            this.minVal = '';
            this.valueChange();
            this.updateUiConfig({
                advanced: type
            });
        }
    }
};
</script>

<style lang="scss">
.search-input-box {
    &.standard {
        color: #515666;
        font-size: 14px;
        .title_container {
            .advance {
                cursor: pointer;
                color: var(--g-btn-background);
            }
        }
    }
    &.template1 {
        font-size: 14px;
        color: #282828;
        .title_container {
            .advance {
                cursor: pointer;
                color: var(--g-btn-background);
            }
        }
    }
    &.template4 {
        font-size: 17px;
        color: #6b7282;
        .title_container {
            .advance {
                cursor: pointer;
                color: var(--g-btn-background);
            }
        }
    }
    .title_container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .content {
        .advance_wrap {
            &.outside {
                padding: 15px;
            }
            .single {
                display: flex;
                align-items: center;
                justify-items: flex-start;
            }
            .multiple {
                display: flex;
                align-items: center;
                justify-items: flex-start;
                .item {
                    height: 100%;
                    flex: 1 0 0;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    color: inherit;
                }
                .split {
                    margin: 0 10px;
                    height: 100%;
                    width: 10px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 50%;
                        width: 100%;
                        height: 1px;
                        background: var(--color-border);
                    }
                }
                &.standard {
                    .split {
                        &::before {
                            background: #c6c8d1;
                        }
                    }
                }
                &.template1 {
                    .split {
                        &::before {
                            background: #dde0ec;
                        }
                    }
                }
                &.template4 {
                    .split {
                        &::before {
                            background: #c6c8d1;
                        }
                    }
                }
            }
            .no_wrap {
                white-space: nowrap;
            }
            .label {
                margin-right: 10px;
                color: inherit;
            }
        }
    
        .outside-advance_wrap {
            .outside_dropdown {
                padding: 15px;
                .single {
                    display: flex;
                    align-items: flex-start;
                    justify-items: flex-start;
                    .item {
                        align-items: flex-start !important;
                    }
                }
                .multiple {
                    display: flex;
                    align-items: flex-start;
                    justify-items: flex-start;
                    .item {
                        align-items: flex-start !important;
                    }
                    .item {
                        height: 100%;
                        flex: 1 0 0;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        color: inherit;
                    }
                    .split {
                        margin: 0 10px;
                        height: 40px;
                        width: 10px;
                        position: relative;
                        &::before {
                            content: '';
                            position: absolute;
                            left: 0;
                            top: 50%;
                            width: 100%;
                            height: 1px;
                        }
                    }
                    &.standard {
                        .split {
                            &::before {
                                background: #c6c8d1;
                            }
                        }
                    }
                    &.template1 {
                        .split {
                            &::before {
                                background: #dde0ec;
                            }
                        }
                    }
                    &.template4 {
                        .split {
                            &::before {
                                background: #c6c8d1;
                            }
                        }
                    }
                }
                .no_wrap {
                    white-space: nowrap;
                }
                .label {
                    height: 40px;
                    line-height: 40px;
                    margin-right: 10px;
                    color: inherit;
                }
            }
            .advanceBtn {
                height: 40px;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                &.standard {
                    border-top: solid 1px #ebecf1;
                    color: var(--g-btn-background);
                    &:hover {
                        background-color: rgba(0, 10, 30, 0.1);
                    }
                }
                &.template1 {
                    border-top: solid 1px #d5d5d5;
                    color: var(--g-btn-background);
                    &:hover {
                        background-color: rgba(0, 10, 30, 0.1);
                    }
                }
                &.template4 {
                    border-top: solid 1px #ebecf1;
                    color: var(--g-btn-background);
                    &:hover {
                        background-color: rgba(0, 10, 30, 0.1);
                    }
                }
            }
        }
    
        /* height: 40px; */
        .normal {
            display: flex;
            align-items: stretch;
            justify-items: flex-start;
            &.outside {
                padding: 15px;
            }
    
            .item {
                height: 100%;
                flex: 1 0 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 0;
            }
            .split {
                margin: 0 10px;
                width: 10px;
                height: 40px;
                position: relative;
                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 100%;
                    height: 1px;
                }
            }
            &.standard {
                .split {
                    &::before {
                        background: #c6c8d1;
                    }
                }
            }
            &.template1 {
                .split {
                    &::before {
                        background: #dde0ec;
                    }
                }
            }
            &.template4 {
                .split {
                    &::before {
                        background: #c6c8d1;
                    }
                }
            }
            &.broker {
                .split {
                    &::before {
                        background: #dadada;
                    }
                }
            }
        }
    }
}

</style>
